import BaseEndpoint from '@spa/apps/trustup-pro-base-js/endpoints/BaseEndpoint';
import OpportunityMeetingCollection from '../collections/OpportunityMeetingCollection';
import OpportunityMeeting from '../models/OpportunityMeeting';

export default class OpportunityMeetingEndpoint extends BaseEndpoint
{

    constructor()
    {
        super(
            'worksite',
            {
                'path': 'opportunities/opportunity-uuid/meetings',
                'responseKey': 'meeting',
                'responseKeyPlural': 'meetings',
                'modelClass': OpportunityMeeting,
                'collectionClass': OpportunityMeetingCollection
            }
        );
    }

    setOpportunity(opportunity)
    {
        this.opportunity = opportunity;
        return this;
    }

    newCollection(models)
    {
        return new this.collectionClass(
            models,
            this.opportunity
        );
    }

    getPath()
    {
        return this.path.replace('opportunity-uuid', this.opportunity.uuid);
    }

    async updateCompletionStatus(uuid, completed_at)
    {   
        return await this.update({
            url: `${this.getPath()}/${uuid}/completion-status`,
            uuid,
            data: {completed_at}
        });
    }

}